var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import IconContainer from "./IconContainer";
const CopyIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (React.createElement(IconContainer, Object.assign({ className: classNames("gerudo-icon-copy", size, className) }, props),
        React.createElement("svg", { width: "24", height: "24", viewBox: "6 6 24 24", fill: "none", "aria-label": title, xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("title", null, title),
            React.createElement("path", { d: "M12.1667 20.5H11.3334C10.8914 20.5 10.4675 20.3244 10.1549 20.0118C9.84234 19.6993 9.66675 19.2754 9.66675 18.8333V11.3333C9.66675 10.8913 9.84234 10.4674 10.1549 10.1548C10.4675 9.84225 10.8914 9.66666 11.3334 9.66666H18.8334C19.2754 9.66666 19.6994 9.84225 20.0119 10.1548C20.3245 10.4674 20.5001 10.8913 20.5001 11.3333V12.1667M17.1667 15.5H24.6667C25.5872 15.5 26.3334 16.2462 26.3334 17.1667V24.6667C26.3334 25.5871 25.5872 26.3333 24.6667 26.3333H17.1667C16.2463 26.3333 15.5001 25.5871 15.5001 24.6667V17.1667C15.5001 16.2462 16.2463 15.5 17.1667 15.5Z", stroke: "currentColor", strokeWidth: "1.66667", strokeLinecap: "round", strokeLinejoin: "round" }))));
};
export { CopyIcon };
export default CopyIcon;
//# sourceMappingURL=Copy.js.map